import { SVGProps, Ref, forwardRef } from 'react';

export const LineArrowRightEnterOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M6.328 11.829 10.157 8 6.328 4.172l-.99.99L7.477 7.3H.5v1.4h6.977L5.338 10.84z"
                        fill="currentColor"
                    />
                    <path
                        d="M15.5 8c0 6.563-.937 7.5-7.5 7.5v-1.4c1.63 0 2.808-.06 3.681-.225.86-.162 1.287-.4 1.54-.654.253-.253.492-.68.654-1.54.165-.873.225-2.051.225-3.681s-.06-2.808-.225-3.681c-.162-.86-.4-1.287-.654-1.54-.253-.253-.68-.492-1.54-.654C10.808 1.96 9.63 1.9 8 1.9V.5c6.563 0 7.5.938 7.5 7.5"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
LineArrowRightEnterOutlinedSize16Glyph.displayName = 'LineArrowRightEnterOutlinedSize16Glyph';
